// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2bR5v","colCheckbox":"styles_colCheckbox__3FBF_"};